// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SnackbarService } from '@coa/app/libs/services/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class CompareSharedService {

  constructor(
    private router: Router,
    private snackbar: SnackbarService,
  ) {
  }

  contains(id: string, selections: string[]): boolean {
    return selections
      ? selections
        .map(selection => selection.toString())
        .includes(id.toString())
      : false;
  }

  removeSelection(id: string, selections: string[], activatedRoute: ActivatedRoute): void {
    const filter = selections.filter(c => c.toString() !== id.toString());
    this.router.navigate([], {
      relativeTo: activatedRoute,
      queryParams: {
        selections: filter.length > 0 ? filter : undefined,
      },
      queryParamsHandling: 'merge',
    });
  }

  addSelectionToCompare(id: string, selections: string[], activatedRoute: ActivatedRoute): void {
    if (selections.length <= 2) {
      this.router.navigate([], {
        relativeTo: activatedRoute,
        queryParams: {
          selections: [].concat(selections, id),
        },
        queryParamsHandling: 'merge',
      });
    } else {
      this.snackbar.open('Compare up to 3 items!', 'top');
    }
  }

  addSelectionToCreate(id: string, selections: string[], activatedRoute: ActivatedRoute): void {
    this.router.navigate([], {
      relativeTo: activatedRoute,
      queryParams: {
        selections: [].concat(selections, id),
      },
      queryParamsHandling: 'merge',
    });
  }

  getSelectionsFrom(params: Params): string[] {
    return params.selections
      ? [].concat(params.selections)
      : [];
  }
}
